import { call, put, takeLatest } from "redux-saga/effects";
import {
    GET_LEAVETYPES,
    ADD_LEAVETYPES,    
    UPDATE_LEAVETYPES,
    DELETE_LEAVETYPES,
    GET_LEAVETYPES_SUCCESS,
    ADD_LEAVETYPES_SUCCESS,
    UPDATE_LEAVETYPES_SUCCESS,
    DELETE_LEAVETYPES_SUCCESS,
    GET_CONFIGUREMAIL_SUCCESS,
    CREATE_CONFIGUREMAIL_SUCCESS,
    GET_CONFIGUREMAIL,
    CREATE_CONFIGUREMAIL,
    GET_REQUESTTYPE,
    GET_REQUESTTYPE_SUCCESS
  
} from "../../redux/actions/actionType";
import api from "../../apis/api";

// api function.
function getLeavesApi()  {
  // api for get employeetype
 const response = api.empSkill().GetLeaveAndDutyTypes();
  return response;
}
function getConfigureMailApi()  {
  // api for get employeetype
 const response = api.dbLeaveTypes().GetConfigurationMailList();
  return response;
}
function getRequestTypeApi()  {
  // api for get employeetype
 const response = api.dbLeaveTypes().GetRequestTypeList();
  return response;
}
function addLeavesApi(formData) {
  // api for add  employeetype.
  api.dbLeaveTypes().AddEditLeaveTypes(formData);
}
function addConfigureMailApi(formData) {
  // api for add  employeetype.
  api.dbLeaveTypes().AddConfigureMail(formData);
}
function updateLeavesApi(formData) {
  // api for update  employeetype.
  api.dbLeaveTypes().AddEditLeaveTypes(formData);
}
function deleteLeavesApi(formData) {
  // api for delete  employeetype.
  const response = api.dbLeaveTypes().DeleteLeaveTypes(formData.delId,formData.type);
  return response;
}

export function* handleGetLeaves() {
  try {
    const response = yield call(getLeavesApi);
    yield put({ type: GET_LEAVETYPES_SUCCESS, payload: response.data });
  } catch (error) {
     
  }
}
export function* handleGetConfigureMail() {
  try {
    const response = yield call(getConfigureMailApi);
    yield put({ type: GET_CONFIGUREMAIL_SUCCESS, payload: response.data });
  } catch (error) {
     
  }
}
export function* handleGetRequestTypeMail() {
  try {
    const response = yield call(getRequestTypeApi);
    yield put({ type: GET_REQUESTTYPE_SUCCESS, payload: response.data });
  } catch (error) {
     
  }
}
export function* handleAddLeaves({ payload }) {
  try {
    yield call(addLeavesApi, payload);
    yield put({ type: ADD_LEAVETYPES_SUCCESS, payload: payload });
  } catch (error) {
     
  }
}
export function* handleAddConfigureMail({ payload }) {
  try {
    yield call(addConfigureMailApi, payload);
    yield put({ type: CREATE_CONFIGUREMAIL_SUCCESS, payload: payload });
  } catch (error) {
     
  }
}
export function* handleUpdateLeaves({ payload }) {
  try {
    let formData = payload;
    yield call(updateLeavesApi, formData);
    yield put({ type: UPDATE_LEAVETYPES_SUCCESS, payload: formData });
  } catch (error) {
     
  }
}
export function* handleDeleteLeaves({ payload }) {
  try {
    yield call(deleteLeavesApi, payload);
    yield put({ type: DELETE_LEAVETYPES_SUCCESS, payload: payload });
  } catch (error) {
     
  }
}

// watach function.
export function* leavetypeWatchFun() {
  yield takeLatest(GET_LEAVETYPES, handleGetLeaves);
  yield takeLatest(ADD_LEAVETYPES, handleAddLeaves);
  yield takeLatest(UPDATE_LEAVETYPES, handleUpdateLeaves);
  yield takeLatest(DELETE_LEAVETYPES, handleDeleteLeaves);
  yield takeLatest(GET_CONFIGUREMAIL,handleGetConfigureMail);
  yield takeLatest(CREATE_CONFIGUREMAIL,handleAddConfigureMail);
  yield takeLatest(GET_REQUESTTYPE,handleGetRequestTypeMail);
}